<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card class="edit-nickname-modal" rounded="lg">
      <v-card-text class="modal-content">
        <!-- Title -->
        <h2 class="modal-title">{{ $t('broker.servers.modal.title') }}</h2>

        <!-- Description -->
        <p class="modal-description">
          {{ $t('broker.servers.modal.description') }}
        </p>

        <!-- Note -->
        <p class="modal-note">
          {{ $t('broker.servers.modal.note') }}
        </p>

        <!-- Input field -->
        <div class="form-field">
          <label class="field-label">{{ $t('broker.servers.modal.nicknameLabel') }}</label>
          <v-text-field
            v-model="nicknameValue"
            :placeholder="$t('broker.servers.modal.nicknamePlaceholder')"
            outlined
            dense
            hide-details
            autofocus
            class="nickname-input"
            @keyup.enter="handleSave"
          />
        </div>
      </v-card-text>

      <v-card-actions class="modal-actions">
        <v-btn
          large
          rounded
          class="cancel-btn"
          height="40"
          @click="handleCancel"
        >
          {{ $t('broker.servers.modal.cancelBtn') }}
        </v-btn>

        <v-btn
          large
          rounded
          class="save-btn"
          height="40"
          :loading="loading"
          @click="handleSave"
        >
          {{ $t('broker.servers.modal.saveBtn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditNicknameModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nicknameValue: ''
    }
  },
  computed: {
    dialog: {
      get() {
        return this.isOpen
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal && this.group) {
        this.nicknameValue = this.group.groupNickname || ''
      }
    },
    group: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.nicknameValue = newVal.groupNickname || ''
        }
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('close')
    },
    handleSave() {
      this.$emit('save', {
        groupId: this.group.id,
        nickname: this.nicknameValue.trim()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.edit-nickname-modal {
  background-color: #FFFFFF !important;
  padding: 0 !important;
}

.modal-content {
  padding: 32px 32px 0 32px !important;
}

.modal-title {
  font-family: 'Aeonik', sans-serif !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  line-height: 32px !important;
  color: #14161B !important;
  margin-bottom: 16px;
}

.modal-description {
  font-family: 'Avenir LT Std', 'Avenir', sans-serif;
  font-size: 14px;
  font-weight: 350;
  line-height: 1.5;
  color: #3B3B3B;
  margin-bottom: 8px;
}

.modal-note {
  font-family: 'Avenir LT Std', 'Avenir', sans-serif;
  font-size: 14px;
  font-weight: 350;
  line-height: 1.5;
  color: #ABABAB;
  margin-bottom: 24px;
}

.form-field {
  margin-bottom: 0;
}

.field-label {
  display: block;
  font-family: 'Avenir LT Std', 'Avenir', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #14161B;
  margin-bottom: 8px;
}

.nickname-input {
  ::v-deep .v-input__slot {
    min-height: 44px !important;
    background: #fff;
  }

  ::v-deep fieldset {
    border-color: #3B3B3B;
  }

  ::v-deep input {
    font-family: 'Avenir LT Std', 'Avenir', sans-serif;
    font-size: 16px;
    padding: 10px 16px !important;
  }

  ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: #28EA96;
    border-width: 2px;
  }
}

.modal-actions {
  padding: 24px 32px 32px 32px !important;
  display: flex;
  gap: 16px;
}

.cancel-btn.v-btn.v-btn.v-btn {
  flex: 1;
  background-color: #EBEBEB !important;
  border: none !important;
  color: #14161B !important;
  text-transform: none !important;
  font-family: 'Aeonik', sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
  box-shadow: none !important;

  &:hover {
    background-color: #DFDFDF !important;
  }
}

.save-btn.v-btn.v-btn {
  flex: 1;
  background-color: #28EA96 !important;
  color: #005931 !important;
  text-transform: none !important;
  font-family: 'Aeonik', sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
  box-shadow: none !important;

  &:hover {
    background-color: #1fd985 !important;
  }
}
</style>
